// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"42d9bcb5","453":"753fb5f2"}[chunkId] + ".chunk.js";
};